import { Component, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute, Params } from "@angular/router";
import { MatDialog } from "@angular/material/dialog";
import { AbstractComponent } from "./abstract/abstract.component";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { HeaderComponent } from "./incs/header.component";
import { FormsModule } from "@angular/forms";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "kilowant-forgot-password",
    templateUrl: "../../html/main-user-forgot-password.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, FormsModule]
})
export class ForgotPasswordComponent extends AbstractComponent {
    showError: boolean = false;
    error: string = "";
    showForm: boolean = false;
    changePasswordMode: boolean = false;
    forgotPasswordLinkSent: boolean = false;
    showSendActivation: boolean = false;
    login: string = "";
    operationCompleted: boolean = false;
    password: string = "";
    password2: string = "";
    data: string = "";
    passwordType: string = "password";
    passwordType2: string = "password";

    constructor(
        router: Router,
        route: ActivatedRoute,
        private authService: AuthService,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        dialog: MatDialog) {
        super(router, route, dialog, analyticsService, generalService);
    }

    ngOnDestroy() {
    }

    ngOnInit(): void {
        if (this.authService.isLoggedIn()) {
            this.router.navigate(["/user/home"], { queryParams: { redirect: this.router.url } });
        }
        this.route.queryParams.forEach((params: Params) => {
            let data: string = params["data"];
            if (data == null || data == "") {
                this.changePasswordMode = false;
                this.refreshView();
            } else {
                firstValueFrom(this.generalService.forgotPasswordCheck(data)).then(
                    (res: any) => {
                        this.data = data;
                        this.showForm = true;
                        this.changePasswordMode = true;
                        this.refreshView();
                    },
                    (err) => {
                        this.changePasswordMode = false;
                        this.refreshView();
                    }
                );
            }
        });

        if (this.generalService.getFromSession("loginEmail") != null) {
            this.login = <string>this.generalService.getFromSession("loginEmail");
        }

    }

    showPassword(num: number) {
        if (num == 1) {
            if (this.passwordType === "password") {
                this.passwordType = "text";
            } else {
                this.passwordType = "password";
            }
        } else {
            if (this.passwordType2 === "password") {
                this.passwordType2 = "text";
            } else {
                this.passwordType2 = "password";
            }
        }
    }

    sendForm(): void {
        if (this.password == null || this.password.length == 0 || this.password2 == null || this.password2.length == 0) {
            this.showError = true;
            this.error = "Please enter the data requested above in order to register.";
            return;
        }
        if (this.password.length < 8) {
            this.showError = true;
            this.error = "Password shall be at least 8 characters long.";
            return;
        }
        if (this.password != this.password2) {
            this.showError = true;
            this.error = "Passwords do not match.";
            return;
        }

        firstValueFrom(this.generalService.forgotPassword(this.data, this.password)).then(
            (res: any) => {
                if (res) {
                    this.operationCompleted = true;
                    this.refreshView();
                }
            },
            (err) => {
                if (err.status == 400) {
                    this.showError = true;
                    this.error = err.error;
                    this.refreshView();
                }
            }
        );
    }

    sendForgotPasswordLink(): void {
        firstValueFrom(this.generalService.remindPassword(this.login)).then(
            (response: any) => {
                this.forgotPasswordLinkSent = true;
                this.refreshView();
            },
            (err: any) => {
                if (err.status == 400 && err.error == "No Activation") {
                    this.showError = false;
                    this.error = "";
                    this.showSendActivation = true;
                    this.refreshView();
                }
                if (err.status == 400 && err.error != "No Activation") {
                    this.showError = true;
                    this.showSendActivation = false;
                    this.error = err.error;
                    this.refreshView();
                }
            }
        );
    }

    resetError(): void {
        this.showError = false;
        this.refreshView();
    }
}
